import React, { Component } from 'react';
import StepZilla from 'react-stepzilla';
import {
	Card,
	CardBody,
	CardTitle
} from 'reactstrap';
import jQuery from 'jquery';

import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';

class formSteps extends Component {
	constructor(props) {
		super(props);
		this.state = {};

		this.sampleStore = {
			email: '',
			gender: '',
			savedToCloud: false
		};
	}

	getStore() {
		return this.sampleStore;
	}

	updateStore(update) {
		this.sampleStore = {
			...this.sampleStore,
			...update,
		}
	}

	async componentDidMount(evt) {
		jQuery(".opendefault").next('.card-body').show();
		jQuery(".opendefault").addClass('active');
	  }
	
	  h5Click = (event) => { 
	  // jQuery(event.target).parent().siblings('.card').find('.card-body').slideUp('slow');
	  // jQuery(event.target).parent().siblings('.card').find('h5').removeClass('active');
	  jQuery(event.target).parent().find('.card-body').slideToggle('slow');
	  jQuery(event.target).toggleClass('active');
	  }

	render() {
		const steps =
			[
				{ name: 'Welcome', component: <Step1 getStore={() => (this.getStore())} updateStore={(u) => { this.updateStore(u) }} /> },
				{ name: 'Personal Details', component: <Step2 getStore={() => (this.getStore())} updateStore={(u) => { this.updateStore(u) }} /> },
				{ name: 'Physical Details', component: <Step3 getStore={() => (this.getStore())} updateStore={(u) => { this.updateStore(u) }} /> },
				{ name: 'Done', component: <Step4 getStore={() => (this.getStore())} updateStore={(u) => { this.updateStore(u) }} /> },
				{ name: 'Last Edit', component: <Step5 getStore={() => (this.getStore())} updateStore={(u) => { this.updateStore(u) }} /> }
			]

		return (
			<Card>
			{/* <CardTitle><i className="icon-circle icon-pencil"></i>Trademark Registration</CardTitle> */}
				<CardBody>
					<div className='example'>
						<div className='step-progress'>
							<StepZilla
							stepsNavigation={false}
								steps={steps}
								nextTextOnFinalActionStep={"Save"}
							/>
						</div>
					</div>
				</CardBody>
			</Card>

		)
	}
}

export default formSteps;
